import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/cascade';

// remove after cascade version
const useStyles = createUseStyles({
  // qx code.
  customHeader: {
    padding: `0 ${Spacings.s16}`,
    '& div:nth-child(2)': {
      marginTop: '5px',
    },
    '&::after': {
      boxShadow: 'none',
    },
  },
});

export default useStyles;
